export default __webpack_public_path__ + "static/media/pin-selected.58cfdfa4.svg";